import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Api } from 'src/app/core/api/Api';
import type { DWSConfig } from './dws.model';

@Injectable({
  providedIn: 'root',
})
export class DwsService {
  constructor(private http: HttpClient) {}

  getDWSConfig(): Observable<DWSConfig> {
    return this.http.get(Api.DWS) as Observable<DWSConfig>;
  }

  getLinks(baseUrl: string) {
    // https://volksbank-pur.dev.meindepotwechsel.de

    baseUrl = baseUrl.replace('.dev', '');
    baseUrl = baseUrl.replace('.test', '');

    console.log(baseUrl);

    return {
      testUrl: baseUrl.replace('.meindepotwechsel', '.test.meindepotwechsel'),
      prodUrl: baseUrl,
    };
  }
}
